import { render, staticRenderFns } from "./AdminRole.vue?vue&type=template&id=3fd12e4c&scoped=true"
import script from "./AdminRole.vue?vue&type=script&lang=js"
export * from "./AdminRole.vue?vue&type=script&lang=js"
import style0 from "./AdminRole.vue?vue&type=style&index=0&id=3fd12e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd12e4c",
  null
  
)

export default component.exports